<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useTemplateRef } from 'vue'
import { ElImage } from 'element-plus'
import { downloadLinkTarget } from '@/util'
import RlThumbOverlay from './RlThumbOverlay.vue'

withDefaults(defineProps<{ url: string; className?: string; deletable?: boolean; deletePending?: boolean }>(), {
  className: '',
  deletable: false,
  deletePending: false,
})

const emit = defineEmits(['delete'])

const elImageRef = useTemplateRef('elImageRef')

const downloadImage = (url: string) => downloadLinkTarget(url, url.split('/').pop() || 'image.jpg')

const showPreview = () => {
  if (!elImageRef.value) return
  elImageRef.value.showPreview()
}
</script>

<template>
  <!-- Should be provided an appropiate-size container to fill up, otherwise will collapse to min  -->
  <div :class="`relative min-w-16 min-h-16 group aspect-square ${className}`">
    <el-image
      ref="elImageRef"
      class="absolute w-full h-full rounded"
      fit="contain"
      :src="url"
      :preview-src-list="[url]"
      :hide-on-click-modal="true"
    />
    <RlThumbOverlay>
      <slot name="overlay-actions" />

      <!-- Default actions -->
      <Icon
        v-if="deletable && !deletePending"
        class="cursor-pointer"
        :height="20"
        icon="mdi:trash-can-outline"
        @click="emit('delete')"
      />
      <Icon v-if="deletable && deletePending" class="cursor-pointer" :height="20" icon="eos-icons:three-dots-loading" />
      <Icon
        v-if="elImageRef"
        class="cursor-pointer"
        :height="20"
        icon="material-symbols:preview-outline"
        @click="showPreview"
      />
      <Icon class="cursor-pointer" :height="20" icon="material-symbols:download" @click="downloadImage(url)" />
    </RlThumbOverlay>
  </div>
</template>
